import React, { useEffect, useState } from "react";
import Loader from "../../../../components/Loader/Loader";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import { checkUserPermission } from "../../../../common/UserPermission";
import { Link } from "react-router-dom";
import RoleTierTableRows from "./RoleTierTableRows";
import axios from "axios";
import config from "../../../../config/config";

import {
  ALREADY_EXIST,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../../../common/Constant";

import { toastError, toastSuccess, toastWarn } from "../../../../common/Toast";
// The below variable are for permission given to the Functionalities
let PERMISSION_ADD_EDIT = "add-edit-attributes";

export const RoleTier = () => {
  const [rowsData, setRowsData] = useState([]);
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID");

  const addTableRows = () => {
    const rowsInput = {
      name: "",
      code: "",
      isactive: false,
    };

    setRowsData([...rowsData, rowsInput]);
  };

  const handleChangeTableRow = (index, evnt) => {
    let id, name, values, code;
    if (evnt.target === undefined) {
      name = "values";
      values = evnt.toString();
    } else {
      name = evnt.target.name;
      values = evnt.target.value;
      // code= evnt.target.code
      // console.log(code)
    }

    const rowstierInput = [...rowsData];

    rowstierInput[index][name] = values;

    rowstierInput[index].code = "Tier" + (Number(index) + 1);

    setRowsData(rowstierInput);
  };
  console.log(rowsData);

  // const handleChangeTableRowIsActive = (index, evnt) => {
  //   let name, values;
  //   name = "isactive";
  //   values = evnt.target.checked ? 1 : 0;
  //   const checkedCount = rowsData.filter((row) => row.isactive === 1).length;

  //   if (evnt.target.checked && checkedCount <= 5) {
  //     const rowstierInput = [...rowsData];
  //     rowstierInput[index][name] = values;
  //     setRowsData(rowstierInput);
  //   } else {
  //     const rowstierInput = [...rowsData];
  //     rowstierInput[index][name] = values;
  //     setRowsData(rowstierInput);
  //   }
  // };

  const handleChangeTableRowIsActive = (index, evnt) => {
    let name, values;
    name = "isactive";
    values = evnt.target.checked ? 1 : 0;

    const checkedCount = rowsData.filter((row) => row.isactive === 1).length;

    // Allow checking/unchecking if checkedCount is less than 5 or if unchecking an already checked row
    if (checkedCount < 5 || !evnt.target.checked) {
      const rowstierInput = [...rowsData];
      rowstierInput[index][name] = values;
      setRowsData(rowstierInput);
    } else if (evnt.target.checked) {
      // Show toast notification if trying to check when already 5 are checked
      toastError("You can only select up to 5 items as active.");
    }
  };

  const handleSubmit = (event) => {
    let data = rowsData.filter(function (rowData) {
      return rowData.name != "";
    });

    const jsonobj = {};
    jsonobj.roletierxml = data;

    let jsonstring = JSON.stringify(jsonobj);

    setLoading(true);

    axios
      .post(
        `${config.storeConfigBaseUrl}/storeconfig/RoletierUpsert`,
        {
          loginuserid: loginUserId,
          xmlroletier: jsonstring,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
          // window.history.back();
          // history.goBack();
          // navigate(-1);
          // event.stopPropagation();
          // window.history.back();
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError("Name" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }

        setLoading(false);
        // window.location.reload();
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setLoading(true);

    // previousPage = localStorage.getItem("previousPage");
    axios
      .get(`${config.storeConfigBaseUrl}/storeconfig/RoletierGetAll`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        const responseData = response.data.ResponseData;
        console.log("responseData ===>", responseData);
        let newResponseData = responseData.map((item, i) => {
          return {
            name: item.Name,
            code: item.Code,
            isactive: item.IsActive,
          };
        });
        setRowsData(newResponseData);

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  console.log(rowsData);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className=" container-fluid">
          {/* Page Header */}
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <div className="col d-flex"> */}
              {/* <h5 className="page-title">Role Tier</h5> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">Manage RoleTier</li>
              </ul>
              {/* </div> */}
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <form>
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th width="5%"></th>
                        <th width="25%">Name</th>
                        <th width="5%">Active</th>
                        {/* {checkUserPermission(PERMISSION_DELETE) ? (
                          <th width="5%">Delete</th>
                        ) : (
                          ""
                        )} */}
                      </tr>
                    </thead>
                    <tbody>
                      <RoleTierTableRows
                        rowsData={rowsData}
                        // deleteTableRows={deleteTableRows}
                        handleChange={handleChangeTableRow}
                        handleChangeActive={handleChangeTableRowIsActive}
                      />
                    </tbody>
                  </table>
                </div>
                <div>
                  <span className="bold text-danger">
                    Note: you can't add more then 5 tier.
                  </span>
                </div>
                {checkUserPermission(PERMISSION_ADD_EDIT) ? (
                  <>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-dark  btn-sm pull-left mt-3"
                      onClick={addTableRows}
                      disabled={rowsData.length >= 5}
                    >
                      <i className="fa fa-plus fa-sm" /> Add Attribute
                    </button>
                  </>
                ) : (
                  ""
                )}
                {checkUserPermission(PERMISSION_ADD_EDIT) ? (
                  <button
                    type="button"
                    className="btn btn-sm btn-primary pull-right mt-3"
                    onClick={(e) => handleSubmit(e)}
                  >
                    Save
                  </button>
                ) : (
                  ""
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
